import { environment } from '@environments/environment';

export const ENDPOINTS = {
    apis: {
        assetModels: {
            base: `${environment.baseUrl}/assetmodels`,
        },
        assets: {
            base: `${environment.baseUrl}/assets`,
            bulkValidation: `${environment.baseUrl}/assets/validation`,
            bulkCreation: `${environment.baseUrl}/assets/bulk`,
        },
        companies: `${environment.baseUrl}/companies`,
        dashboards: `${environment.baseUrl}/dashboards`,
        devices: {
            base: `${environment.baseUrl}/devices`,
            firmwareVersions: `${environment.baseUrl}/devices/fwversions`,
            serial: `${environment.baseUrl}/devices/serial`,
        },
        domains: `${environment.baseUrl}/domains`,
        events: {
            companies: `${environment.baseUrl}/events/companies`,
            assets: `${environment.baseUrl}/events/assets`,
        },
        issues: `${environment.baseUrl}/issues`,
        login: {
            base: `${environment.baseUrl}/login`,
            refreshToken: `${environment.baseUrl}/login/refreshtoken`,
        },
        predictions: {
            base: `${environment.baseUrl}/predictions`,
            assets: `${environment.baseUrl}/predictions/assets`,
        },
        reports: `${environment.baseUrl}/reports`,
        timezones: `${environment.baseUrl}/timezones`,
        userGroups: `${environment.baseUrl}/usergroups`,
        users: {
            base: `${environment.baseUrl}/users`,
            zendeskSSO: `${environment.baseUrl}/users/zendesksso`,
            zendeskArticles: `${environment.baseUrl}/users/zendeskarticles`,
        },
        viewgroups: {
            base: `${environment.baseUrl}/viewgroups`,
            companies: `${environment.baseUrl}/viewgroups/companies`,
        },
    },
    data: {
        countries: 'assets/data/countries.json',
        vulnerabilities: 'assets/data/vulnerabilities.<lang>.json',
        help: 'assets/data/help.json',
    },
    customerApi: {
        assets: `${environment.customerApiUrl}/assets`,
        token: `${environment.customerApiUrl}/login/token`,
        companies: `${environment.customerApiUrl}/companies`,
    },
    urls: {
        assets: {
            list: '/admin/assets',
            new: '/ng1/asset_new.html',
            edit: '/ng1/asset_edit.html',
            detail: '/ng1/assets_detail.html',
        },
        companySettings: '/admin/',
        dashboard: {
            base: '/dashboard',
            explore: '/dashboard/explore',
            utilization: '/ng1/dashboard.html?_release_version_&tab=util',
            cost: '/ng1/dashboard.html?_release_version_&tab=cost',
            alerts: '/ng1/dashboard.html?_release_version_&tab=alerts',
            smartReports: '/dashboard/smart-reports',
        },
        login: '/login',
        modelManager: '/ng1/model_manager.html',
        modelViewer: '/ng1/model_viewer.html',
        profileSettings: '/user-settings',
        search: '/ng1/search.html',
        sigsense: 'https://www.sigsensetech.com',
        pageNotFound: '/not-found',
        policies: {
            privacy: 'https://www.agilent.com/home/privacy-policy',
        },
    },
    helpCenter: {
        base: 'https://community.agilent.com/technical/power-monitoring/w/wiki',
        gettingStarted:
            'https://community.agilent.com/getting-started/w/community-help/4924/how-to-create-an-account-in-the-agilent-community',
        explore:
            'https://community.agilent.com/technical/power-monitoring/w/wiki/26925/getting-started-with-explore',
    },
};

export const API_RESPONSE_LIMITS = {
    all: 999999,
    default: 1000,
};
